import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { MdlManageOportunity } from '../mdl-manage-opportunity/mdl-manage-opportunity';

@Component({
  selector: 'app-mdl-select-company-type',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './mdl-public-private.html',
  styleUrl: './mdl-public-private.css',
})
export class MdlSelectCompanyType {
  public selectedType: 'publica' | 'privada' | null = null;

  private dialog = inject(MatDialog);
  public dialogRef = inject(MatDialogRef<MdlSelectCompanyType>);

  selectType(type: 'publica' | 'privada') {
    this.selectedType = type;
  }

  openOpportunityForm() {
    if (!this.selectedType) return;

    this.dialog.open(MdlManageOportunity, {
      minWidth: '800px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'create',
        privada_publica: this.selectedType === 'publica' ? 'Empresa publica' : 'Empresa privada'
      }
    });

    this.dialogRef.close(); 
  }

  closeModal() {
    this.dialogRef.close();
  }
}